<template lang="pug">
  div
    map-heat(@change='onChange' v-if='hasGeoHeatMap' )
    div.legend__group
      div(
        style="display: block!important;"
      ).legend__type
        .legend__under
          label.legend__label.semibold Подложка
          select.select.legend__select(v-model="rosreestr_view")
            option(value="osm" v-if='hasOsmTile' ) OSM
            option(value="yandex") Яндекс.Карты
            option(value="satellite") Яндекс.Спутник
</template>

<script>
import { REGION_CONFIG } from '@/config/regions'
import hasMixin from '@/mixins/has-mixin'

import mapHeat from '../components/map-heat'

export default {
  name: 'mno-map-mapping-selector',
  components: { mapHeat },
  mixins: [hasMixin],
  props: {
    mappingConfObject: Object,
    selectedMappingObject: [Number, String],
  },
  data() {
    return {
      rosreestr_view: REGION_CONFIG.rosreestr_view,
      selected: '',
    }
  },
  computed: {
    availableTiles() {
      const arr = {
        yandex: 'yandex',
        satellite: 'satellite',
      }

      if (this.hasOsmTile) {
        arr.osm = 'osm'
      }
      return arr
    },
  },
  watch: {
    selectedMappingObject: 'onSelectedMappingObject',
    rosreestr_view: 'onRosreestrChangeView',
  },
  methods: {
    onRosreestrChangeView(value) {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, tile: value },
      })
      this.$emit('rosreestrChangeView', value)
    },
    onSelectedMappingObject(val) {
      this.selected = val
    },
    onChange(value) {
      this.$emit('change', value)
    },
  },
  mounted() {
    this.$emitter.listen('mapInit', () => {
      if (this.$route?.query?.tile) {
        this.rosreestr_view =
          this.availableTiles[this.$route.query.tile] ??
          REGION_CONFIG.rosreestr_view
      }
    })
  },
}
</script>
